import React from "react";

const GelNailArtBook = () => {
  return (
    <div className="nailSalonBookContainer">
      <h5>Book Your Appointment Today</h5>
      <p>
        Ready to get stunning gel nails? Booking an appointment for "{" "}
        <a href="https://scentlifestyle.com/gel-nail-art">
          {" "}
          Gel Nail Art in Bangalore
        </a>{" "}
        " at SCENT is easy. Simply call the salon or visit their website to
        schedule your session. Whether you're preparing for a special event or
        just want to treat yourself, <a href="/">SCENT</a> has you covered.
      </p>
    </div>
  );
};

export default GelNailArtBook;
